var map = {
	"./Anyswap.png": 467,
	"./Anyswap.svg": 468,
	"./Artwork.svg": 469,
	"./Artwork_fxdx.svg": 470,
	"./Banxa.png": 471,
	"./DROP_DOWN.svg": 274,
	"./Hop.png": 472,
	"./Hop.svg": 473,
	"./Hop_dark.png": 474,
	"./Hop_dark.svg": 475,
	"./Synapse.png": 476,
	"./Synapse.svg": 477,
	"./binance.png": 478,
	"./bscscan.png": 479,
	"./btn_big_arbitrum.png": 480,
	"./btn_big_avalanche.png": 481,
	"./btn_big_bsc.png": 482,
	"./btn_big_purchasegmx.png": 483,
	"./btn_big_purchasegmx.svg": 484,
	"./buy_fxdx.svg": 275,
	"./buy_fxdx_bond.svg": 485,
	"./buy_transfer_eth.svg": 486,
	"./coinbaseWallet.png": 276,
	"./coingecko.png": 487,
	"./cross.svg": 488,
	"./flag_en.svg": 489,
	"./flag_es.svg": 490,
	"./flag_fr.svg": 491,
	"./flag_ja.svg": 492,
	"./flag_ko.svg": 493,
	"./flag_ru.svg": 494,
	"./flag_zh.svg": 495,
	"./flp_icon.svg": 496,
	"./fxdx-logo-final-white-small.png": 497,
	"./fxdx-logo-final-white.png": 498,
	"./fxdx-logo-final.png": 499,
	"./fxdx-logo-glow.png": 500,
	"./fxdx-logo-with-name.svg": 501,
	"./fxdx_logo.svg": 502,
	"./graphite-01.png": 503,
	"./ic-communityproject.svg": 504,
	"./ic_arbitrum_16.svg": 191,
	"./ic_arbitrum_24.svg": 149,
	"./ic_arbitrum_96.svg": 277,
	"./ic_arbitrum_hover_16.svg": 505,
	"./ic_arrowleft16.svg": 506,
	"./ic_arrowright16.svg": 507,
	"./ic_avalanche_16.svg": 192,
	"./ic_avalanche_24.svg": 165,
	"./ic_avalanche_96.svg": 278,
	"./ic_avax_24.svg": 508,
	"./ic_avax_30.svg": 509,
	"./ic_avax_40.svg": 510,
	"./ic_banxa.svg": 511,
	"./ic_binance_logo.svg": 512,
	"./ic_bsc.svg": 513,
	"./ic_bsc_96.svg": 514,
	"./ic_btc.b_24.svg": 515,
	"./ic_btc.b_40.svg": 516,
	"./ic_btc_24.svg": 517,
	"./ic_btc_40.svg": 518,
	"./ic_busd_24.svg": 519,
	"./ic_busd_40.svg": 520,
	"./ic_buy_flp.svg": 279,
	"./ic_cash.png": 521,
	"./ic_cash.svg": 522,
	"./ic_checked.svg": 193,
	"./ic_coingecko_16.svg": 280,
	"./ic_coingecko_hover_16.svg": 523,
	"./ic_convert_down.svg": 281,
	"./ic_copy_16.svg": 282,
	"./ic_cost.svg": 283,
	"./ic_dai_24.svg": 524,
	"./ic_dai_40.svg": 525,
	"./ic_discord.svg": 284,
	"./ic_eth_24.svg": 526,
	"./ic_eth_40.svg": 527,
	"./ic_ethereum_16.svg": 166,
	"./ic_ethereum_24.svg": 134,
	"./ic_ethereum_96.svg": 528,
	"./ic_flp_24.svg": 529,
	"./ic_flp_40.svg": 530,
	"./ic_flp_custom.svg": 531,
	"./ic_frax_24.svg": 532,
	"./ic_frax_40.svg": 533,
	"./ic_fxdx.svg": 534,
	"./ic_fxdx_24.svg": 535,
	"./ic_fxdx_30.svg": 536,
	"./ic_fxdx_40.svg": 537,
	"./ic_fxdx_64.svg": 538,
	"./ic_fxdx_arbitrum.svg": 539,
	"./ic_fxdx_avax.svg": 540,
	"./ic_fxdx_big.svg": 541,
	"./ic_fxdx_custom.svg": 542,
	"./ic_fxdx_footer.svg": 543,
	"./ic_github.svg": 285,
	"./ic_glmr_24.svg": 544,
	"./ic_glmr_40.svg": 545,
	"./ic_hop.svg": 546,
	"./ic_info.svg": 547,
	"./ic_language24.svg": 167,
	"./ic_link_24.svg": 548,
	"./ic_link_40.svg": 549,
	"./ic_liquidity.svg": 286,
	"./ic_medium.svg": 287,
	"./ic_menu_dots.svg": 550,
	"./ic_metamask_16.svg": 288,
	"./ic_metamask_hover_16.svg": 551,
	"./ic_mim_24.svg": 552,
	"./ic_mim_40.svg": 553,
	"./ic_moonbeam_16.svg": 194,
	"./ic_moonbeam_200.svg": 554,
	"./ic_moonbeam_24.svg": 168,
	"./ic_multiswap.svg": 555,
	"./ic_new_link_16.svg": 289,
	"./ic_olympus.svg": 556,
	"./ic_olympus_arbitrum.svg": 557,
	"./ic_selector_dropdowns.svg": 558,
	"./ic_settings_16.svg": 234,
	"./ic_settings_24.svg": 559,
	"./ic_sign in_16.svg": 560,
	"./ic_sign_out_16.svg": 290,
	"./ic_simpleswaps.svg": 291,
	"./ic_stats.svg": 292,
	"./ic_stats_big.svg": 561,
	"./ic_synapse.svg": 562,
	"./ic_telegram.svg": 293,
	"./ic_tether_24.svg": 563,
	"./ic_tokens.svg": 564,
	"./ic_totaluser.svg": 294,
	"./ic_trading.svg": 295,
	"./ic_transfer_avax.svg": 565,
	"./ic_twitter.svg": 296,
	"./ic_uni_24.svg": 566,
	"./ic_uni_40.svg": 567,
	"./ic_usdc(m)_24.svg": 568,
	"./ic_usdc(m)_40.svg": 569,
	"./ic_usdc(w)_24.svg": 570,
	"./ic_usdc(w)_40.svg": 571,
	"./ic_usdc.e_24.svg": 572,
	"./ic_usdc.e_40.svg": 573,
	"./ic_usdc_24.svg": 574,
	"./ic_usdc_40.svg": 575,
	"./ic_usdt_24.svg": 576,
	"./ic_usdt_40.svg": 577,
	"./ic_wallet_24.svg": 297,
	"./ic_wavax_24.svg": 578,
	"./ic_wavax_40.svg": 579,
	"./ic_wbtc(m)_24.svg": 580,
	"./ic_wbtc(m)_40.svg": 581,
	"./ic_wbtc(w)_24.svg": 582,
	"./ic_wbtc(w)_40.svg": 583,
	"./ic_wbtc_24.svg": 584,
	"./ic_wbtc_40.svg": 585,
	"./ic_weth_24.svg": 586,
	"./ic_weth_40.svg": 587,
	"./ic_wglmr_24.svg": 588,
	"./ic_wglmr_40.svg": 589,
	"./lg_arbitrum.svg": 590,
	"./logo.png": 99,
	"./logo_FXDX.svg": 591,
	"./logo_FXDX_small.svg": 592,
	"./long.svg": 298,
	"./metamask-text.svg": 593,
	"./metamask.png": 299,
	"./page-not-found.svg": 594,
	"./position-share-bg.png": 300,
	"./short.svg": 301,
	"./swap.svg": 302,
	"./trading.jpg": 595,
	"./wallet-connect-text.svg": 596,
	"./walletconnect-circle-blue.svg": 303,
	"./wave-01.png": 597,
	"./wave-02.png": 598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 466;